module.exports = __webpack_public_path__ + "static/img/slider-bg.1534e78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-bg.jpg
// module id = hmMf
// module chunks = 7